import { Component } from "@angular/core";
import { MessagingService } from './services/messaging.service';
import { DataSharingService } from './services/data.share.service';


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false
})
export class AppComponent {
  title = "Tax Canary";

  urlnumber: any;
  sub2: any;
  ishide: boolean = false;
  ishidesidebar: any;
  message: any;
  constructor(
    private dataSharingService: DataSharingService, private messagingService: MessagingService) {

    //   this.sub2 = this.dataSharingService.newMessageRecive.subscribe((item:any) => {
    //     this.ishide =item;
    //     if (item) {

    //       this.ishidesidebar = localStorage.getItem('isShowsidebar');

    //     }
    //   this.urlnumber = localStorage.getItem('isLoginPg');
    //   // let urlnumber1 = window.location.href.split('/')[window.location.href.split('/').length - 1];
    // //  // console.log(this.urlnumber)
    //   if(this.urlnumber == 'login'){
    //     this.ishide=true;
    //   }
    // });
  }
  ngOnInit() {
    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage;
  }
}
